import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorModeValue,
  Stack,
  useColorMode,
  Avatar,
  Image,
  Divider,
  Icon,
  Text,
  Badge,
  VStack
} from '@chakra-ui/react';
import { FaUserCircle, FaSignOutAlt, FaLock, FaMoon, FaSun } from 'react-icons/fa';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useAdminLogoutMutation } from '../../slices/adminApiSlice.js';
import { logout } from '../../slices/adminAuthSlice.js';

const AdminHeader = () => {
  const { adminInfo } = useSelector((state) => state.adminAuth);
  const dispatch = useDispatch();
  const [logoutApiCall] = useAdminLogoutMutation();
  const navigate = useNavigate();
  const { colorMode, toggleColorMode } = useColorMode();

  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');
  const menuBgColor = useColorModeValue('gray.50', 'gray.700');
  const hoverBgColor = useColorModeValue('gray.200', 'teal.600');
  const headerTextColor = useColorModeValue('teal.600', 'teal.200');

  const logOutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
    } catch (err) {
      // const errorMessage =
      //   err.message === "Failed to fetch"
      //     ? "Network error. Please check your internet connection and try again."
      //     : "Something went wrong. Please try again.";
      //console.error(errorMessage);
    } finally {
      // Always log out locally, even if the API call fails
      dispatch(logout());
      navigate("/admin");
    }
  };

  return (
    <Box bg={bgColor} px={6} py={3} boxShadow="md" position="sticky" top="0" zIndex="1000">
      <Flex alignItems="center" justifyContent="space-between">
        {/* Logo & Branding */}
        {/* <Flex alignItems="center">
          <Image src="/logo512.png" alt="iFun Baby Logo" boxSize="50px" mr={3} />
          <Heading as={RouterLink} to="/admin" size="md" color={textColor}>
            iFun Baby <Text as="span" color={headerTextColor}>Rewards</Text>
          </Heading>
          <Text fontSize="s" color="gray.400">
              v {process.env.REACT_APP_VERSION || '1.0.0'}
          </Text>
        </Flex> */}
        <Flex alignItems="center">
          <Image src="/logo512.png" alt="iFun Baby Logo" boxSize="50px" mr={3} />

          <Flex alignItems="center">
            <Heading
              as={RouterLink}
              to="/admin"
              size="md"
              color={textColor}
              mr={2}
            >
              iFun Baby <Text as="span" color={headerTextColor}>Rewards</Text>
            </Heading>

            <Text
              fontSize="xs"
              color="gray.400"
              border="1px solid"
              borderColor="gray.300"
              px={2}
              py={0.5}
              borderRadius="md"
            >
              v {process.env.REACT_APP_VERSION || '1.0.0'}
            </Text>
          </Flex>
        </Flex>

        {/* Right Section (Profile & Theme Toggle) */}
        {adminInfo && (
          <Flex alignItems="center">
            <Stack direction="row" spacing={5}>
              {/* Dark Mode Toggle */}
              <Button onClick={toggleColorMode} variant="ghost" colorScheme="teal">
                <Icon as={colorMode === 'light' ? FaMoon : FaSun} />
              </Button>

              {/* Profile Menu */}
              <Menu>
                <MenuButton as={Button} variant="ghost" colorScheme="teal">
                  <Flex alignItems="center">
                    <Avatar
                      size="sm"
                      name={adminInfo.name}
                      src={adminInfo.image_url || '/default.png'}
                      mr={2}
                    />
                    <Text fontSize="sm">{adminInfo.name}</Text>
                  </Flex>
                </MenuButton>
                <MenuList bg={menuBgColor} boxShadow="lg" py={3} borderRadius="md">
                  {/* Profile Section */}
                  <VStack spacing={2} align="center" p={4}>
                    <Avatar size="lg" src={adminInfo.image_url || '/default.png'} />
                    <Text fontWeight="bold" fontSize="md">
                      {adminInfo.name}
                    </Text>
                    <Badge colorScheme="teal" borderRadius="full" px={2} py={1}>
                      Admin
                    </Badge>
                  </VStack>

                  <Divider />

                  {/* Menu Items */}
                  <MenuItem as={RouterLink} to="/admin/profile" _hover={{ bg: hoverBgColor }}>
                    <Icon as={FaUserCircle} mr={2} /> Profile
                  </MenuItem>
                  <MenuItem as={RouterLink} to="/admin/change-password" _hover={{ bg: hoverBgColor }}>
                    <Icon as={FaLock} mr={2} /> Change Password
                  </MenuItem>

                  <Divider />

                  {/* Logout Button */}
                  <MenuItem onClick={logOutHandler} color="red.500" _hover={{ bg: 'red.100' }}>
                    <Icon as={FaSignOutAlt} mr={2} /> Logout
                  </MenuItem>
                </MenuList>
              </Menu>
            </Stack>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default AdminHeader;
